export const SmartMeetCol = {
  NAME: 'name',
  CREATED_ON: 'created_on',
  MODIFIED_ON: 'modified_on',
  STATUS: 'status_code',
  DURATION: 'duration',
  ACTIONS: 'actions'
};

export enum SMART_MEET_TABS {
  SUMMARY = 0,
  TRANSCRIPT = 1,
  ACTION_ITEMS = 2,
  NOTES = 3
}

export enum MEETING_UPDATE_OPTION {
  UPDATE = 'update',
  REGENERATE = 'regenerate',
  RENAME_SPEAKERS = 'rename_speakers',
  REGENERATE_SUMMARY = 'regenerate_summary'
}
